
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { ImportExcelFile } from './ImportExcelFile'
import { Category, ImportStatistics } from '@/types'

interface ImportExcelDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onCategoriesImported: (categories: Category[]) => void;
}

export function ImportExcelDialog({
  isOpen,
  onOpenChange,
  onCategoriesImported
}: ImportExcelDialogProps) {
  const [importedCategories, setImportedCategories] = useState<Category[]>([]);
  const [importStatistics, setImportStatistics] = useState<ImportStatistics | null>(null);
  const [showStatistics, setShowStatistics] = useState(false);

  const handleImport = () => {
    onCategoriesImported(importedCategories);
    onOpenChange(false);
  };

  const handleStatisticsGenerated = (statistics: ImportStatistics) => {
    setImportStatistics(statistics);
  };

  const handleShowStatistics = () => {
    setShowStatistics(true);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Import from Excel</DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <ImportExcelFile
            onCategoriesImported={setImportedCategories}
            onStatisticsGenerated={handleStatisticsGenerated}
            onShowStatistics={handleShowStatistics}
          />
        </div>

        {showStatistics && importStatistics && (
          <div className="mb-4 p-4 border rounded bg-secondary/20">
            <h3 className="text-sm font-medium mb-2">Import Statistics</h3>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div>Total Categories: {importStatistics.totalCategories || 0}</div>
              <div>Root Categories: {importStatistics.rootCategories || 0}</div>
              <div>Total Mapping Rules: {importStatistics.totalMappingRules || 0}</div>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button
            onClick={handleImport}
            disabled={importedCategories.length === 0}
          >
            Import {importedCategories.length} Categories
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
